var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0833 6.81055V24.4126C32.0833 25.8126 30.9458 27.1251 29.5458 27.3001L29.0645 27.3585C25.8854 27.7814 20.9853 29.4001 18.1853 30.9459C17.8062 31.1647 17.1791 31.1647 16.7854 30.9459L16.727 30.9168C13.927 29.3856 9.04167 27.7814 5.87709 27.3585L5.45411 27.3001C4.05411 27.1251 2.91663 25.8126 2.91663 24.4126V6.79595C2.91663 5.06054 4.33117 3.74805 6.06659 3.89388C9.12909 4.1418 13.7666 5.68767 16.3624 7.30642L16.727 7.52512C17.1499 7.78762 17.85 7.78762 18.2729 7.52512L18.5208 7.36472C19.4396 6.79597 20.6062 6.22722 21.875 5.7168V11.6668L24.7916 9.72722L27.7083 11.6668V4.05437C28.102 3.98145 28.4812 3.93765 28.8312 3.90848H28.9187C30.6541 3.76265 32.0833 5.06055 32.0833 6.81055Z",
    stroke: "",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.00586V29.8809",
    stroke: "",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7083 4.05469V11.6671L24.7917 9.72754L21.875 11.6671V5.71712C23.7854 4.95879 25.9146 4.34635 27.7083 4.05469Z",
    stroke: "",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/BookIcon.d55cba388aaa6b8ec24e775e98b500d0.svg";
export { ForwardRef as ReactComponent };